module.exports = __webpack_public_path__ + "static/img/img-logo.19214fe3.png";